import { RELATION_DEPLOYED_BY } from '@appfolio/backstage-plugin-deployments-common';
import { Entity } from '@backstage/catalog-model';

export const isDeploymentsAvailable = (entity: Entity) =>
  entity.relations?.some(r => r.type === RELATION_DEPLOYED_BY) ?? false;
